import auth0 from 'auth0-js';
import jwtDecode from 'jwt-decode';
import fp from 'lodash/fp';
import queryString from 'query-string';
import React from 'react';
import { connect } from 'react-redux';
import { compose, lifecycle } from 'recompose';
import { bindActionCreators } from 'redux';
import { sessionActions } from '../../state/modules/session';
import { Loading } from './';

/**
 * Responsible handling a redirect back to our site after an auth0 redirect
 */

const Authenticate = () => (
  <Loading />
);

function checkAuthentication(currentProps) {
  const {
    auth0Config,
    authenticate,
    logout,
    location,
    externalAuthConfig
  } = currentProps;

  if (auth0Config) {
    const webAuth = new auth0.WebAuth({
      clientID: auth0Config.clientId,
      domain: auth0Config.domain
    });

    const invitationToken = queryString.parse(location.search).invitationToken;
    const customRedirect = queryString.parse(location.search).customRedirect;

    webAuth.parseHash({ hash: window.location.hash }, function (err, authResult) {
      if (err || !authResult) {
        const parsedHash = queryString.parse(location.hash)
        const idToken = parsedHash.id_token
        const { iss } = jwtDecode(idToken)
        if (fp.includes(iss)(externalAuthConfig.providers)) {
          authenticate(idToken, undefined, invitationToken, customRedirect);
        } else {
          logout();
        }
      } else {
        authenticate(authResult.idToken, undefined, invitationToken, customRedirect);
      }
    });
  }
}

const mapStateToProps = (state) => ({
  auth0Config: state.configuration.auth0Config,
  externalAuthConfig: state.configuration.externalAuthConfig
});

const mapDispatchToProps = (dispatch) => ({
  authenticate: bindActionCreators(sessionActions.session.authenticate, dispatch),
  logout: bindActionCreators(sessionActions.session.logout, dispatch)
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  lifecycle({
    componentDidMount() {
      checkAuthentication(this.props)
    },
    componentWillReceiveProps(nextProps) {
      checkAuthentication(nextProps)
    }
  }),
)(Authenticate);



// WEBPACK FOOTER //
// ./src/containers/pages/authenticate.js